import { inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import {
  HttpErrorResponse,
  HttpInterceptorFn
} from '@angular/common/http';

import { Router } from '@angular/router';

import { catchError, throwError } from 'rxjs';

import { CookiesService } from '../loginpage/cookies.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
let username = '';
  const cookies = inject(CookiesService);

  const router = inject(Router);

  const userData = cookies.getCookie('userData');
  const toastr = inject(ToastrService);

  let token = '';

  if (userData) {

    const data = typeof userData === 'string'
      ? JSON.parse(userData)
      : userData;

    token = data?.access_token;
    username =data?.redmine_context?.user?.login

  }

  // clone request with token
  const authReq = token
    ? req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
          username: username
        }
      })
    : req;

  return next(authReq).pipe(

    catchError((error: HttpErrorResponse) => {

  // TOKEN EXPIRED / UNAUTHORIZED
if (error.status === 401) {

  // Show message
  toastr.warning(
    'Your session has expired. Please login again.',
    'Session Expired'
  );

  // Remove cookie
  cookies.deleteCookie('userData');

  // Clear storage
  localStorage.clear();
  sessionStorage.clear();

  // Small delay so toast is visible before navigation
  setTimeout(() => {
    if (router.url !== '/login') {
      router.navigateByUrl('/login');
    }
  }, 1000); // 1 second
}
      return throwError(() => error);

    })

  );

};